import { OrderStatus } from './order.model';

export interface Customer {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  nickname?: string | null;
  dateOfBirth: Date | null;
  gender?: string | null;
  currentStage?: string | null;
  lastStageTransitionAt?: string | null;
  phones: Phone[];
  electronicAddresses: ElectronicAddress[];
  profilePictureUrl?: string | null;
  countryOfOrigin?: string | null;
  documents?: CustomerDocument[];
  cards?: CustomerCard[];
  orders?: CustomerOrder[];
  addresses?: CustomerAddress[];
  stageHistories?: CustomerStageHistory[];
}

export interface CustomerList {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phone: string;
  dateOfBirth: Date;
  gender?: string;
}

export interface Phone {
  id: string;
  countryCode: string;
  number: string;
  type: string;
  isDefault: boolean;
  isVerified: boolean;
}

export interface ElectronicAddress {
  id: string;
  address: string;
  type: string;
  isDefault: boolean;
  isVerified: boolean;
}

export interface CustomerDocument {
  id: string;
  number: string;
  type: CustomerDocumentType;
  parameters: CustomerDocumentParameter[];
}

export interface CustomerDocumentParameter {
  id: string;
  key: string;
  value: string;
}

export interface CustomerCard {
  id: string;
  type: string;
  displayNumber: string;
  brand: string;
  expirationMonth: 0;
  expirationYear: 0;
  holderName: string;
  isDefault: boolean;
}

export interface CustomerOrder {
  id: string;
  number: string;
  status: OrderStatus;
  placedAt: Date;
  productName: string;
  fullPrice: 0;
}

export interface CustomerAddress {
  id: string;
  street: string;
  complement?: string;
  city: string;
  state: string;
  zipCode: string;
  country: string;
  type: AddressType;
  isDefault: boolean;
}

export interface CustomerStageHistory {
  id: string;
  from?: CustomerRegistrationStage;
  to: CustomerRegistrationStage;
  transitionedAt: Date;
}

export enum AddressType {
  Home,
  Work,
  Billing,
  Shipping,
}

export enum CustomerDocumentType {
  NationalId = 1,
  BusinessRegistration = 2,
  DriverLicense = 3,
  Passport = 4,
  WorkPermit = 5,
}

export enum CustomerRegistrationStage {
  AccountCreated = 1,
  AccountValidated = 2,
  PasswordCreated = 3,
  Active = 4,
}
